/* eslint-disable @typescript-eslint/brace-style */
import { BigNumber, BigNumberish, constants, utils } from 'ethers'
import { cutPrecision, formatBigNumber } from 'src/utils/format/formatBigNumber'

export function getReadableNumber(value: BigNumberish, precision = 2, decimals = 18): string {
  if (!value) {
    return '0'
  }

  if (BigNumber.from(value).eq(BigNumber.from(0))) {
    return '0'
  }

  return cutPrecision(formatBigNumber(BigNumber.from(value), decimals), precision)
}

export function amountFormatter(
  amount: BigNumber,
  baseDecimals = 18,
  displayDecimals = 2,
  useLessThan = true,
) {
  if (baseDecimals > 18 || displayDecimals > 18 || displayDecimals > baseDecimals) {
    throw Error(
      `Invalid combination of baseDecimals '${baseDecimals}' and displayDecimals '${displayDecimals}.`,
    )
  }
  if (!amount) {
    return undefined
  } else if (amount.isZero()) {
    return `0${displayDecimals === 0 ? '' : '.'}${'0'.repeat(displayDecimals)}`
  } else {
    // amount of 'wei' in 1 'ether'
    const baseAmount = BigNumber.from(10).pow(BigNumber.from(baseDecimals))
    const minimumDisplayAmount = baseAmount.div(
      BigNumber.from(10).pow(BigNumber.from(displayDecimals)),
    )
    // if balance is less than the minimum display amount
    if (amount.lt(minimumDisplayAmount)) {
      return useLessThan
        ? `<${utils.formatUnits(minimumDisplayAmount, baseDecimals)}`
        : `${utils.formatUnits(amount, baseDecimals)}`
    } else {
      // if the balance is greater than the minimum display amount
      const stringAmount = utils.formatUnits(amount, baseDecimals)
      // if there is a decimal portion
      if (stringAmount.match(/\./)) {
        const [wholeComponent, decimalComponent] = stringAmount.split('.')
        console.log({
          wholeComponent,
          decimalComponent,
          withPad: decimalComponent.padEnd(baseDecimals, '0'),
        })
        const roundUpAmount = minimumDisplayAmount.div(constants.Two)
        const roundedDecimalComponent = BigNumber.from(decimalComponent.padEnd(baseDecimals, '0'))
          .add(roundUpAmount)
          .toString()
          .padStart(baseDecimals, '0')
          .substring(-displayDecimals, displayDecimals)

        console.log({ roundedDecimalComponent })
        // decimals are too small to show
        if (roundedDecimalComponent === '0'.repeat(displayDecimals)) {
          return wholeComponent
        } else {
          // decimals are not too small to show
          return `${wholeComponent}.${roundedDecimalComponent.toString()}`
        }
      } else {
        // if there isn't a decimal portion
        return stringAmount
      }
    }
  }
}
